import { Extension } from '@tiptap/core';
function tuiIsListActive(editor) {
  return editor.isActive('bulletList') || editor.isActive('orderedList') || editor.isActive('taskList');
}
const TuiTabExtension = Extension.create({
  name: 'indent',
  addKeyboardShortcuts() {
    return {
      Tab: () => tuiIsListActive(this.editor) ? false : this.editor.commands.insertContent('\t')
    };
  }
});

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTabExtension, tuiIsListActive };
